
import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { CHART_COLORS } from "./BudgetChartData";

// Custom PieChart label component to display only percentage in the pie segment
const renderCustomizedPieLabel = (entry: any) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  } = entry;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
  const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);
  return <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central" fontSize="12" fontWeight="bold">
      {`${(percent * 100).toFixed(0)}%`}
    </text>;
};

// Custom tooltip for the pie chart to show subcategory and budget information
const CustomPieTooltip = ({
  active,
  payload
}: any) => {
  if (active && payload && payload.length) {
    return <div className="bg-background/95 border border-border p-2 rounded-md shadow-md">
        <p className="font-semibold">{`${payload[0].name}`}</p>
        <p className="text-sm">{`Budget: $${payload[0].value.toLocaleString()}`}</p>
      </div>;
  }
  return null;
};

interface PieChartComponentProps {
  data: Array<{name: string, value: number, color: string}>;
}

export const PieChartComponent: React.FC<PieChartComponentProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie 
          data={data} 
          cx="50%" 
          cy="50%" 
          labelLine={false} 
          outerRadius={100} 
          fill="#8884d8" 
          dataKey="value" 
          nameKey="name" 
          label={renderCustomizedPieLabel}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip content={<CustomPieTooltip />} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
